// eslint-disable-next-line import/prefer-default-export
export const PublicRoutes = {
  AUTHORIZED: "/authorized",
};
